module.exports = __webpack_public_path__ + "static/media/icon.1ae43532.svg";